import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export function Proof() {
  return <div className="bg-brand-green text-white py-24 px-6" data-id="element-134">
      <AnimatedSection className="max-w-4xl mx-auto" data-id="element-135">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-brand-cream" data-id="element-136">
          ¿Qué cambia en 7 días?
        </h2>

        <div className="space-y-8" data-id="element-137">
          <div className="bg-white/10 p-8 rounded-2xl border border-white/20 backdrop-blur-sm" data-id="element-138">
            <h3 className="text-2xl font-bold mb-4 text-brand-amber" data-id="element-139">
              Para el día 4
            </h3>
            <p className="text-xl" data-id="element-140">
              La hinchazón en tus pies y tobillos empezará a reducirse
              notablemente.
            </p>
          </div>

          <div className="bg-white/10 p-8 rounded-2xl border border-white/20 backdrop-blur-sm" data-id="element-141">
            <h3 className="text-2xl font-bold mb-4 text-brand-amber" data-id="element-142">
              Para el día 7
            </h3>
            <p className="text-xl" data-id="element-143">
              Notarás que tus dedos tienen más rango de movimiento y que esa
              "niebla mental" matutina ha desaparecido, permitiéndote empezar el
              día con claridad y sin quejidos.
            </p>
          </div>
        </div>
      </AnimatedSection>
    </div>;
}